export const headerCompaniesWithoutKeyContactsStyle = theme => ({
    title: {
        flexGrow: 1,
    },
    linearbar: {
        height: "2px !important"
      },
})